(() => {
  const setupDepositGallery = (gallery) => {
    if (!gallery || gallery.dataset.xdenDepositReady === 'true') return;
    gallery.dataset.xdenDepositReady = 'true';

    const slides = [...gallery.querySelectorAll('[data-deposit-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-deposit-thumb]')];
    const count = gallery.querySelector('[data-deposit-count]');
    const previous = gallery.querySelector('[data-deposit-prev]');
    const next = gallery.querySelector('[data-deposit-next]');
    let current = 0;

    const activate = (nextIndex) => {
      current = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => { slide.hidden = index !== current; });
      thumbs.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(index === current)));
      if (count) count.textContent = `${current + 1}/${slides.length}`;
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => activate(index)));
    previous?.addEventListener('click', () => activate(current - 1));
    next?.addEventListener('click', () => activate(current + 1));
    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') activate(current - 1);
      if (event.key === 'ArrowRight') activate(current + 1);
    });

    let touchStartX = 0;
    let touchStartY = 0;
    gallery.addEventListener('touchstart', (event) => {
      const touch = event.changedTouches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });
    gallery.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;
      if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY)) return;
      activate(current + (deltaX < 0 ? 1 : -1));
    }, { passive: true });

    activate(0);
  };

  const setupDepositProductForm = (container) => {
    if (!container || container.dataset.xdenDepositFormReady === 'true') return;
    container.dataset.xdenDepositFormReady = 'true';

    const form = container.querySelector('form');
    if (!form) return;
    const variantId = Number(container.dataset.depositVariantId);
    const cartUrl = container.dataset.cartUrl;
    const cartJsonUrl = container.dataset.cartJsonUrl;
    const cartAddUrl = container.dataset.cartAddUrl;
    const button = form.querySelector('[type="submit"]');
    const message = form.querySelector('[data-deposit-product-message]');
    const defaultLabel = button?.textContent.trim() || 'Reserve My XDen — $50';

    const showMessage = (copy) => {
      if (!message) return;
      message.textContent = copy;
      message.hidden = false;
    };

    const getCart = async () => {
      const response = await fetch(cartJsonUrl, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart could not be checked.');
      return response.json();
    };

    const alreadyReserved = (cart) => cart.items?.some((item) => Number(item.variant_id) === variantId && item.quantity >= 1);

    const syncLimit = async () => {
      try {
        const cart = await getCart();
        if (!alreadyReserved(cart)) return false;
        if (button) {
          button.disabled = true;
          button.textContent = 'Deposit already in cart';
        }
        showMessage('Only one XDen deposit can be purchased per order.');
        return true;
      } catch (_error) {
        return false;
      }
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!button || button.dataset.busy === 'true') return;
      button.dataset.busy = 'true';
      button.disabled = true;
      button.textContent = 'Checking cart…';
      if (message) message.hidden = true;

      try {
        const cart = await getCart();
        if (alreadyReserved(cart)) {
          button.textContent = 'Deposit already in cart';
          showMessage('Only one XDen deposit can be purchased per order.');
          return;
        }

        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!response.ok) throw new Error('Deposit could not be added to cart.');
        window.location.assign(cartUrl);
      } catch (error) {
        button.disabled = false;
        button.textContent = defaultLabel;
        button.dataset.busy = 'false';
        showMessage(error.message || 'Please try again.');
      }
    });

    syncLimit();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-deposit-gallery]').forEach(setupDepositGallery);
    root.querySelectorAll('[data-deposit-product-form]').forEach(setupDepositProductForm);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
